import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
type LocalizedField = Record<string, string>;

@Pipe({
  name: 'localized',
  standalone: true,
  pure: false,
})
export class TranslateLocalizedPipe implements PipeTransform {
  constructor(private translateService: TranslateService) {}

  transform(value: LocalizedField | null | undefined): string {
    if (!value) return '';
    const lang = this.translateService.currentLang || this.translateService.getDefaultLang();
    return value[lang] || value['en'] || '';
  }
}
